import React, { useEffect } from "react";
import { Header } from "../components/header/Header";
import { Carousel } from "../components/modules/Carousel/carousel";
import { DiscoveryMarket } from "../components/modules/Discovery/DiscoveryMarket";
import { Guarantee } from "../components/modules/guarantee/Guarantee";
import { PerkContent } from "../components/modules/Perk/content";
import { Perk } from "../components/modules/Perk/perk";
import * as perkStyle from "../components/modules/Perk/perk.module.scss";
import SEO from "../components/seo";
import cbb from "../images/cbb.png";
import gouttes from "../images/gouttes.jpg";
import "../styles/global.css";

const autodose: React.FC = () => {
  const displayPerk = (entries: any, observer: any) => {
    entries.forEach((entrie: any) => {
      if (entrie.target.classList && entrie.isIntersecting) {
        entrie.target.classList.add(perkStyle.perkAnim);
      }
    });
  };

  useEffect(() => {
    setTimeout(() => {
      const observer0 = new IntersectionObserver(displayPerk, {
        threshold: 0.65,
      });
      const target2 = document.querySelector("#perk2");
      const target3 = document.querySelector("#perk3");
      if (!observer0) {
        target2 && target2.classList.add(perkStyle.perkAnim);
        target3 && target3.classList.add(perkStyle.perkAnim);
      } else {
        target2 && observer0.observe(target2);
        target3 && observer0.observe(target3);
      }
    }, 1000);
  }, []);

  return (
    <>
      <SEO title={`Whirlpool | Autodose`} />

      <>
        <Header silence={false} />
        <Carousel silence={false} />
        <Perk image={gouttes} styleImg={{ objectFit: "contain" }}>
          <PerkContent
            id="perk2"
            overTitle="Autodose"
            title="Chaque goutte compte"
            content={`Réaliser des économies de lessive à chaque cycle est essentiel : cela compte pour vous, pour votre linge, et pour la planète.

Avec Autodose, bénéficiez d'un dosage simplifié et ne risquez jamais de surdosage ! Remplissez une seule fois et profitez jusqu'à 26 lavages*.`}
            subtitle="*Utilisation d'un réservoir de détergent liquide de 35 ml avec une charge de 5 kg (charge normative de coton selon la norme IEC 60456), et une concentration de détergent de 4X(Mid 20<ml<35)."
          />
        </Perk>
        <Perk image={cbb} imageFirst={true}>
          <PerkContent
            id="perk3"
            overTitle="WaterSave"
            title="La juste quantité d'eau nécessaire, pas une goutte de plus."
            content={`La technologie la plus avancée pour garantir une optimisation des ressources : seule la quantité d'eau nécessaire est utilisée, pas une goutte de plus !

Bénéficiez d'économies d'eau : jusqu'à -59%* d'eau utilisée à chaque cycle (-38L par cycle).`}
            subtitle="*En considérant le cycle Eco 40-60 avec WaterSave et la technologie 6ème SENS."
            button="EN SAVOIR PLUS"
            link={process.env.GATSBY_LINK_LAV0 || ""}
          />
        </Perk>
        <Guarantee />
        <DiscoveryMarket />
      </>
    </>
  );
};
export default autodose;
